export default "__VITE_ASSET__ce231150__"